
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneralOpen as ObiTwowayAcuatorGeneralOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-open.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneralOpen = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-open',
   elementClass: ObiTwowayAcuatorGeneralOpenElement,
   events: {
     
   }
  });
 
 